import styled from 'styled-components';

export const StyledFormInlineDiv = styled.div`
  display: flex;
`;
